/* =========================================================================
   pr-home.js (owner: home). Loaded by layout/pr.liquid on template "index", after the shared PR scripts.
   Scroll drivers only (port of mockup/v3/index.html inline script, no product data lookups: prices, counts and
   photos are rendered by Liquid):
     .hp-hero  --x   0..1 how far the hero has scrolled away (copy lifts + fades, photo settles 1.06 -> 1)
               --hp-rib  ribbon height, so nav + ribbon + hero fill the first screen exactly
     .hp-brand --q   0..1 film progress: 0 when the section top is at 60% of the viewport, 1 when the pin releases
   Sections register with PR.sections.register, so they work after theme-editor section reloads.
   ========================================================================= */
(function () {
  'use strict';
  var w = window, d = document;
  var PR = w.PR;
  if (!PR || !PR.sections) return;

  var heroes = [], films = [], ticking = false, bound = false;

  function clamp(v, a, b) { return PR.clamp ? PR.clamp(v, a, b) : Math.min(b, Math.max(a, v)); }
  function reduced() { return PR.reduced ? PR.reduced() : false; }
  function drop(list, el) { var i = list.indexOf(el); if (i > -1) list.splice(i, 1); }

  function size() {
    var r = d.querySelector('.ap-ribbon'), h = 0;
    if (r && r.offsetParent !== null) h = r.offsetHeight;
    heroes.forEach(function (el) { el.style.setProperty('--hp-rib', h + 'px'); });
  }

  function frame() {
    ticking = false;
    var red = reduced(), vh = w.innerHeight, sy = w.scrollY || w.pageYOffset || 0;
    heroes.forEach(function (el) {
      if (!el.isConnected) return;
      var top = el.getBoundingClientRect().top + sy;
      var x = red ? 0 : clamp(sy / Math.max(1, el.offsetHeight + top), 0, 1);
      el.style.setProperty('--x', x.toFixed(4));
    });
    films.forEach(function (el) {
      if (!el.isConnected) return;
      var r = el.getBoundingClientRect(), start = vh * 0.6, span = start + Math.max(0, r.height - vh);
      var q = red ? 1 : clamp((start - r.top) / Math.max(1, span), 0, 1);
      el.style.setProperty('--q', q.toFixed(4));
    });
  }

  function onScroll() { if (!ticking) { ticking = true; w.requestAnimationFrame(frame); } }
  function onResize() { size(); onScroll(); }

  function bind() {
    if (bound) return; bound = true;
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onResize);
    w.addEventListener('load', onResize);
  }

  PR.sections.register('pr-hero', function (el) {
    var hero = el.classList.contains('hp-hero') ? el : el.querySelector('.hp-hero');
    if (!hero || heroes.indexOf(hero) > -1) return;
    heroes.push(hero); bind(); size(); frame();
  }, function (el) {
    var hero = el.classList.contains('hp-hero') ? el : el.querySelector('.hp-hero');
    if (hero) drop(heroes, hero);
  });

  PR.sections.register('pr-film', function (el) {
    var film = el.classList.contains('hp-brand') ? el : el.querySelector('.hp-brand');
    if (!film || films.indexOf(film) > -1) return;
    films.push(film); bind(); frame();
  }, function (el) {
    var film = el.classList.contains('hp-brand') ? el : el.querySelector('.hp-brand');
    if (film) drop(films, film);
  });

  /* the ribbon section can be reloaded in the editor too: re-measure */
  d.addEventListener('shopify:section:load', function () { w.requestAnimationFrame(onResize); });

  PR.home = { refresh: onResize };
})();
